<div class="block mmc-model-history">
  <!--    <div class='sideBarContent content loading-spinner' *ngIf="isLoading"></div>-->
  <div class="block editorDisplayBanner">
    <div class="mmc-model-history-header-block">Attributes of securities in this model have been edited as
      noted below:
    </div>
    <div class="right" style="margin-right: 1px;">
      <span>
        <fa-icon (click)="exportModelHistory()" [icon]="faDownload" [tooltipTitle]="'Export'"
        class="irb-green clickable" id="exportLink" tooltip></fa-icon>
      </span>
    </div>
  </div>


  @if (!isUiTest) {
    <irb-inventory-grid (gridReady)="onGridReady($event)"
      [gridHeight]="'240px'"
      [gridOptions]="gridOptions"
      [showSideBar]="false"
      [style.height]="'240px'"
    [style.width]="'100%'"></irb-inventory-grid>
  }

  @if (ges.getExportOptions().isGridRequired) {
    <irb-ag-grid-export (callbackMethod)="ges.resetExportGrid($event)"
      [exportOptions]="ges.getExportOptions()"
      [exportType]="'csv'"
      [isGridRequired]="ges.getExportOptions().isGridRequired"
    [rowData]="ges.getExportOptions().gridOptions.rowData"></irb-ag-grid-export>
  }
</div>
